<template>
  <div
    v-if="request.isLoading"
    style="
      height: 100vh;
      width: 100vw;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <ProgressSpinner style="" />
  </div>

  <Card v-bind="$attrs" class="p-m-3" v-else>
    <template #title="">
      <span class="table-header">DME Approve</span>
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-12" v-if="!queryGuId && showSelectionSection">
          <div class="p-field">
            <label for="guid" style="display: block !important">GUID</label>
            <InputText id="guid" v-model="request.guId" />
          </div>
        </div>
        <div
          class="p-col p-field p-fluid"
          v-if="!queryGuId && showSelectionSection"
        >
          <SelectButton
            v-model="request.approverId"
            :options="[
              'VP1',
              'VP2',
              'VP3',
              'VP4',
              'VP5',
              'VP6',
              'FP1',
              'COM1',
              'CFO1',
              'COO1',
              'CEO1',
            ]"
          />
        </div>
        <div
          class="p-col-1 p-field p-fluid"
          v-if="!queryGuId && showSelectionSection"
        >
          <span class="p-float-label">
            <InputText
              id="approverYear"
              v-model="request.approverYear"
            ></InputText>
            <label for="approverYear">Approver Year</label>
          </span>
        </div>
        <div class="p-col-fixed" v-if="!queryGuId && showSelectionSection">
          <Button
            icon="pi pi-check"
            @click="() => onLoad()"
            label="ดึงข้อมูลจาก SAP"
          ></Button>
        </div>
        <div class="p-col-12 p-d-flex p-justify-end">
          <Button
            v-if="approveLv1s.length > 0 || approveLv2s.length > 0"
            icon="pi pi-save"
            @click="onSubmit"
            label="Save"
            class="p-button-danger"
            :disabled="
              !showAcceptLevel1 && !showAcceptLevel2 && !showAcceptLevel2Summary
            "
          ></Button>
        </div>
        <div
          class="p-col-12"
          v-if="
            approveLv1s.length > 0 ||
              approveLv2s.length > 0 ||
              approveLv2Summary.length > 0
          "
        >
          <TabView v-model:activeIndex="request.tabIndex" lazy>
            <TabPanel v-if="approveLv1s.length > 0">
              <template #header="">
                <i class="pi pi-list p-mr-2"></i>
                <span :class="isLevel1Completed ? 'tab-success' : 'tab-danger'">
                  {{ level1TabName }}
                </span>
              </template>
              <div class="p-grid">
                <div class="p-col-8 p-fluid" style="margin-top: 1rem">
                  <span
                    class="p-float-label"
                    v-if="approveLv1s[0].yearIndicator !== 'N'"
                  >
                    <Textarea
                      id="yearOverall"
                      v-model="request.yearOverallComment"
                      :disabled="!isLevel1YearAllAccept"
                    ></Textarea>
                    <label for="yearOverall">Year Overall Comment</label>
                  </span>
                </div>
                <div class="p-col-4" v-if="showAcceptLevel1">
                  <span class="p-d-flex p-justify-end">
                    <Button
                      :label="
                        approveLv1s.findIndex((x) => x.approveNeed === 'A') >= 0
                          ? 'Acknowlege All'
                          : 'Approve All'
                      "
                      class="p-button-success"
                      @click="onAcceptAllLevel1"
                    ></Button>
                  </span>
                </div>

                <div class="p-col-12 p-mt-3">
                  <DataTable
                    :value="approveLv1s"
                    class="p-datatable-sm"
                    showGridlines
                    :rowClass="rowClassLevel1Year"
                  >
                    <template #header="">
                      <span class="table-header">Year</span>
                    </template>
                    <Column
                      header="Cost Center Level 1"
                      field="cc1Name"
                    ></Column>
                    <Column
                      header="Current RE"
                      field="yearNew"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.yearNew) }}
                      </template>
                    </Column>
                    <Column
                      header="Prior RE"
                      field="yearOld"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.yearOld) }}
                      </template>
                    </Column>
                    <Column
                      header="Variance"
                      field="yearDifference"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        <div>
                          <dme-arrow
                            :diff="props.data.yearDifference"
                          ></dme-arrow>
                          {{ formatAmount(props.data.yearDifference) }}
                          <div class="variance-percent">
                            {{
                              variancePercent(
                                props.data.yearNew,
                                props.data.yearOld
                              )
                            }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Action">
                      <template #body="props">
                        <div
                          class="p-buttons"
                          v-if="
                            props.data.approveNeed && props.data.yearApproveNeed
                          "
                        >
                          <Button
                            class="p-button-sm p-button-success"
                            :class="{
                              'p-button-text': !props.data.yearApproveYes,
                            }"
                            @click="onApproveLv1(props.data, 'year')"
                            :label="
                              props.data.approveNeed === 'A'
                                ? 'Acknowlege'
                                : 'Approve'
                            "
                          >
                          </Button>
                          <Button
                            v-if="props.data.approveNeed !== 'A'"
                            class="p-button-sm p-button-danger p-ml-2"
                            :class="{
                              'p-button-text': !props.data.yearApproveNo,
                            }"
                            @click="onRejectLv1(props.data, 'year')"
                            label="Reject"
                          >
                          </Button>
                        </div>
                      </template>
                    </Column>
                    <Column header="Comment">
                      <template #body="props">
                        <Textarea
                          v-model="props.data.yearComment"
                          v-if="
                            props.data.approveNeed && props.data.yearApproveNeed
                          "
                          :rows="1"
                          :disabled="
                            !props.data.yearApproveNo &&
                              !props.data.yearApproveYes
                          "
                          style="width: 100%"
                        ></Textarea>
                      </template>
                    </Column>

                    <Column
                      :header="commentVpHeader"
                      field="yearPreviousCommentVp"
                      v-if="commentVpHeader"
                    >
                    </Column>
                    <Column
                      :header="comment1Header"
                      field="yearPreviousComment1"
                      v-if="comment1Header"
                    >
                    </Column>
                    <Column
                      :header="comment2Header"
                      field="yearPreviousComment2"
                      v-if="comment2Header"
                    >
                    </Column>
                    <Column
                      :header="comment3Header"
                      field="yearPreviousComment3"
                      v-if="comment3Header"
                    >
                    </Column>
                    <Column
                      :header="comment4Header"
                      field="yearPreviousComment4"
                      v-if="comment4Header"
                    >
                    </Column>
                    <ColumnGroup type="footer">
                      <Row>
                        <Column
                          footer="Total:"
                          footerStyle="text-align:right"
                        ></Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            {{ formatAmount(totalYearNew) }}
                          </template>
                        </Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            {{ formatAmount(totalYearOld) }}
                          </template>
                        </Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            <div>
                              <dme-arrow :diff="totalYearDiff"></dme-arrow>
                              {{ formatAmount(totalYearDiff) }}
                              <div class="variance-percent">
                                {{
                                  variancePercent(totalYearNew, totalYearOld)
                                }}
                              </div>
                            </div>
                          </template>
                        </Column>
                      </Row>
                    </ColumnGroup>
                  </DataTable>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="hasDisplay && comment1Header"
                >
                  <span class="overallCommentLabel">
                    {{ request.yearOverallComment1.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.yearOverallComment1.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="hasDisplay && comment2Header"
                >
                  <span class="overallCommentLabel">
                    {{ request.yearOverallComment2.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.yearOverallComment2.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="hasDisplay && comment3Header"
                >
                  <span class="overallCommentLabel">
                    {{ request.yearOverallComment3.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.yearOverallComment3.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="hasDisplay && comment4Header"
                >
                  <span class="overallCommentLabel">
                    {{ request.yearOverallComment4.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.yearOverallComment4.split(":")[1] }}
                  </span>
                </div>

                <div
                  class="p-col-12 p-mt-3"
                  v-if="approveLv1s[0].currentQuarter !== 'D'"
                >
                  <DataTable
                    :value="approveLv1s"
                    class="p-datatable-sm"
                    showGridlines
                    :rowClass="rowClassLevel1Current"
                  >
                    <template #header="">
                      <span class="table-header">Current Quarter</span>
                    </template>
                    <Column
                      header="Cost Center Level 1"
                      field="cc1Name"
                    ></Column>
                    <Column
                      header="Current Re"
                      field="currentQuarterNew"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.currentQuarterNew) }}
                      </template>
                    </Column>
                    <Column
                      header="Prior RE"
                      field="currentQuarterOld"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.currentQuarterOld) }}
                      </template>
                    </Column>
                    <Column
                      header="Variance"
                      field="currentQuarterDiff"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        <div>
                          <dme-arrow
                            :diff="props.data.currentQuarterDiff"
                          ></dme-arrow>
                          {{ formatAmount(props.data.currentQuarterDiff) }}
                          <div class="variance-percent">
                            {{
                              variancePercent(
                                props.data.currentQuarterNew,
                                props.data.currentQuarterOld
                              )
                            }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Action">
                      <template #body="props">
                        <div
                          class="p-buttons"
                          v-if="
                            props.data.approveNeed &&
                              props.data.currentQuarterApproveNeed
                          "
                        >
                          <Button
                            class="p-button-sm p-button-success"
                            :class="{
                              'p-button-text': !props.data
                                .currentQuarterApproveYes,
                            }"
                            @click="onApproveLv1(props.data, 'current')"
                            :label="
                              props.data.approveNeed === 'A'
                                ? 'Acknowlege'
                                : 'Approve'
                            "
                          ></Button>
                          <Button
                            v-if="props.data.approveNeed !== 'A'"
                            class="p-button-sm p-button-danger p-ml-2"
                            :class="{
                              'p-button-text': !props.data
                                .currentQuarterApproveNo,
                            }"
                            @click="onRejectLv1(props.data, 'current')"
                            label="Reject"
                          ></Button>
                        </div>
                      </template>
                    </Column>
                    <Column header="Comment">
                      <template #body="props">
                        <Textarea
                          v-model="props.data.currentQuarterComment"
                          v-if="
                            props.data.approveNeed &&
                              props.data.currentQuarterApproveNeed
                          "
                          :rows="1"
                          :disabled="
                            !props.data.currentQuarterApproveNo &&
                              !props.data.currentQuarterApproveYes
                          "
                          style="width: 100%"
                        ></Textarea>
                      </template>
                    </Column>
                    <Column
                      :header="commentVpHeader"
                      field="currentQuarterPreviousCommentVp"
                      v-if="commentVpHeader"
                    >
                    </Column>
                    <Column
                      :header="comment1Header"
                      field="currentQuarterPreviousComment1"
                      v-if="comment1Header"
                    >
                    </Column>
                    <Column
                      :header="comment2Header"
                      field="currentQuarterPreviousComment2"
                      v-if="comment2Header"
                    >
                    </Column>
                    <Column
                      :header="comment3Header"
                      field="currentQuarterPreviousComment3"
                      v-if="comment3Header"
                    >
                    </Column>
                    <Column
                      :header="comment4Header"
                      field="currentQuarterPreviousComment4"
                      v-if="comment4Header"
                    >
                    </Column>
                    <ColumnGroup type="footer">
                      <Row>
                        <Column
                          footer="Total:"
                          footerStyle="text-align:right"
                        ></Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            {{ formatAmount(totalCurrentQuarterNew) }}
                          </template>
                        </Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            {{ formatAmount(totalCurrentQuarterOld) }}
                          </template>
                        </Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            <div>
                              <dme-arrow
                                :diff="totalCurrentQuarterDiff"
                              ></dme-arrow>
                              {{ formatAmount(totalCurrentQuarterDiff) }}
                              <div class="variance-percent">
                                {{
                                  variancePercent(
                                    totalCurrentQuarterNew,
                                    totalCurrentQuarterOld
                                  )
                                }}
                              </div>
                            </div>
                          </template>
                        </Column>
                      </Row>
                    </ColumnGroup>
                  </DataTable>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    approveLv1s[0].currentQuarter !== 'D' &&
                      approveLv1s[0].currentQuarter !== 'N'
                  "
                >
                  <span class="p-float-label">
                    <Textarea
                      id="currentOverall"
                      v-model="request.currentQuarterOverallComment"
                      :disabled="!isLevel1CurrentAllAccept"
                    ></Textarea>
                    <label for="currentOverall">Current Overall Comment</label>
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].currentQuarter !== 'D' &&
                      comment1Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.currentQuarterOverallComment1.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.currentQuarterOverallComment1.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].currentQuarter !== 'D' &&
                      comment2Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.currentQuarterOverallComment2.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.currentQuarterOverallComment2.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].currentQuarter !== 'D' &&
                      comment3Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.currentQuarterOverallComment3.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.currentQuarterOverallComment3.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].currentQuarter !== 'D' &&
                      comment4Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.currentQuarterOverallComment4.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.currentQuarterOverallComment4.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-mt-3"
                  v-if="approveLv1s[0].nextQuarter !== 'D'"
                >
                  <DataTable
                    :value="approveLv1s"
                    class="p-datatable-sm"
                    showGridlines
                    :rowClass="rowClassLevel1Next"
                  >
                    <template #header="">
                      <span class="table-header">Next Quarter</span>
                    </template>
                    <Column
                      header="Cost Center Level 1"
                      field="cc1Name"
                    ></Column>
                    <Column
                      header="Current RE"
                      field="nextQuarterNew"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.nextQuarterNew) }}
                      </template>
                    </Column>
                    <Column
                      header="Prior RE"
                      field="nextQuarterOld"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.nextQuarterOld) }}
                      </template>
                    </Column>
                    <Column
                      header="Variance"
                      field="nextQuarterDiff"
                      headerClass="numeral-column"
                      bodyStyle="text-align:right"
                    >
                      <template #body="props">
                        <div>
                          <dme-arrow
                            :diff="props.data.nextQuarterDiff"
                          ></dme-arrow>
                          {{ formatAmount(props.data.nextQuarterDiff) }}
                          <div class="variance-percent">
                            {{
                              variancePercent(
                                props.data.nextQuarterNew,
                                props.data.nextQuarterOld
                              )
                            }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Action">
                      <template #body="props">
                        <div
                          class="p-buttons"
                          v-if="
                            props.data.approveNeed &&
                              props.data.nextQuarterApproveNeed
                          "
                        >
                          <Button
                            class="p-button-sm p-button-success"
                            :class="{
                              'p-button-text': !props.data
                                .nextQuarterApproveYes,
                            }"
                            @click="onApproveLv1(props.data, 'next')"
                            :label="
                              props.data.approveNeed === 'A'
                                ? 'Acknowlege'
                                : 'Approve'
                            "
                          ></Button>
                          <Button
                            v-if="props.data.approveNeed !== 'A'"
                            class="p-button-sm p-button-danger p-ml-2"
                            :class="{
                              'p-button-text': !props.data.nextQuarterApproveNo,
                            }"
                            @click="onRejectLv1(props.data, 'next')"
                            label="Reject"
                          ></Button>
                        </div>
                      </template>
                    </Column>
                    <Column header="Comment">
                      <template #body="props">
                        <Textarea
                          v-model="props.data.nextQuarterComment"
                          v-if="
                            props.data.approveNeed &&
                              props.data.nextQuarterApproveNeed
                          "
                          :rows="1"
                          :disabled="
                            !props.data.nextQuarterApproveNo &&
                              !props.data.nextQuarterApproveYes
                          "
                          style="width: 100%"
                        ></Textarea>
                      </template>
                    </Column>
                    <Column
                      :header="commentVpHeader"
                      field="nextQuarterPreviousCommentVp"
                      v-if="commentVpHeader"
                    >
                    </Column>
                    <Column
                      :header="comment1Header"
                      field="nextQuarterPreviousComment1"
                      v-if="comment1Header"
                    >
                    </Column>
                    <Column
                      :header="comment2Header"
                      field="nextQuarterPreviousComment2"
                      v-if="comment2Header"
                    >
                    </Column>
                    <Column
                      :header="comment3Header"
                      field="nextQuarterPreviousComment3"
                      v-if="comment3Header"
                    >
                    </Column>
                    <Column
                      :header="comment4Header"
                      field="nextQuarterPreviousComment4"
                      v-if="comment4Header"
                    >
                    </Column>
                    <ColumnGroup type="footer">
                      <Row>
                        <Column
                          footer="Total:"
                          footerStyle="text-align:right"
                        ></Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            {{ formatAmount(totalNextQuarterNew) }}
                          </template>
                        </Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            {{ formatAmount(totalNextQuarterOld) }}
                          </template>
                        </Column>
                        <Column footerStyle="text-align:right">
                          <template #footer>
                            <div>
                              <dme-arrow
                                :diff="totalNextQuarterDiff"
                              ></dme-arrow>
                              {{ formatAmount(totalNextQuarterDiff) }}
                              <div class="variance-percent">
                                {{
                                  variancePercent(
                                    totalNextQuarterNew,
                                    totalNextQuarterOld
                                  )
                                }}
                              </div>
                            </div>
                          </template>
                        </Column>
                      </Row>
                    </ColumnGroup>
                  </DataTable>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    approveLv1s[0].nextQuarter !== 'D' &&
                      approveLv1s[0].nextQuarter !== 'N'
                  "
                >
                  <span class="p-float-label">
                    <Textarea
                      id="nextOverall"
                      v-model="request.nextQuarterOverallComment"
                      :disabled="!isLevel1NextAllAccept"
                    ></Textarea>
                    <label for="nextOverall">
                      Next Quarter Overall Comment
                    </label>
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].nextQuarter !== 'D' &&
                      comment1Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.nextQuarterOverallComment1.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.nextQuarterOverallComment1.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].nextQuarter !== 'D' &&
                      comment2Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.nextQuarterOverallComment2.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.nextQuarterOverallComment2.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].nextQuarter !== 'D' &&
                      comment3Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.nextQuarterOverallComment3.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.nextQuarterOverallComment3.split(":")[1] }}
                  </span>
                </div>
                <div
                  class="p-col-12 p-fluid"
                  v-if="
                    hasDisplay &&
                      approveLv1s[0].nextQuarter !== 'D' &&
                      comment4Header
                  "
                >
                  <span class="overallCommentLabel">
                    {{ request.nextQuarterOverallComment4.split(":")[0] }} :
                  </span>
                  <span>
                    {{ request.nextQuarterOverallComment4.split(":")[1] }}
                  </span>
                </div>
              </div>
            </TabPanel>
            <TabPanel v-if="approveLv2s.length > 0">
              <template #header="">
                <i class="pi pi-list p-mr-2"></i>
                <span :class="isLevel2Completed ? 'tab-success' : 'tab-danger'">
                  {{ level2TabName }}
                </span>
              </template>
              <div class="p-grid">
                <div class="p-col-12" v-if="showAcceptLevel2">
                  <div class="p-d-flex p-justify-end">
                    <span
                      class="p-float-label"
                      v-if="showCommentToNextApprover"
                    >
                      <Textarea
                        style="width: 20rem"
                        id="commentNext"
                        v-model="request.commentToNextApprover"
                      ></Textarea>
                      <label for="commentNext">Comment to next approver</label>
                    </span>
                    <div style="width: 0.5rem"></div>
                    <Button
                      label="Approve All"
                      class="p-button-success"
                      @click="onAcceptAllLevel2"
                    ></Button>
                  </div>
                </div>
                <div class="p-col-12">
                  <DataTable
                    :value="approveLv2s"
                    class="p-datatable-sm"
                    showGridlines
                    :rowClass="rowClassLevel2"
                  >
                    <Column header="Cost Center Level 1">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel1"
                          v-tooltip="props.data.wbsLevel1"
                        >
                          <!--                          {{ props.data.wbsLevel1 }} :-->
                          {{ props.data.wbsLevelDescription1 }}
                        </span>
                      </template>
                    </Column>
                    <Column header="Cost Center Level 2">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel2"
                          v-tooltip="props.data.wbsLevel2"
                        >
                          <!--                          {{ props.data.wbsLevel2 }} :-->
                          {{ props.data.wbsLevelDescription2 }}
                        </span>
                      </template>
                    </Column>
                    <Column header="Campaign">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel4"
                          v-tooltip="props.data.wbsLevel4"
                        >
                          <!--                          {{ props.data.wbsLevel4 }} :-->
                          {{ props.data.wbsLevelDescription4 }}
                        </span>
                      </template>
                    </Column>

                    <!--                    <Column header="Cost Center Level 1 > Cost Center Level 2 > Campaign">-->
                    <!--                      <template #body="props">-->
                    <!--                        <span v-if="props.data.wbsLevel1">-->
                    <!--                          {{ props.data.wbsLevel1 }} :-->
                    <!--                          {{ props.data.wbsLevelDescription1 }}-->
                    <!--                        </span>-->
                    <!--                        <span v-if="props.data.wbsLevel2">-->
                    <!--                          > {{ props.data.wbsLevel2 }} :-->
                    <!--                          {{ props.data.wbsLevelDescription2 }}-->
                    <!--                        </span>-->
                    <!--                        <span v-if="props.data.wbsLevel4">-->
                    <!--                          > {{ props.data.wbsLevel4 }} :-->
                    <!--                          {{ props.data.wbsLevelDescription4 }}-->
                    <!--                        </span>-->
                    <!--                      </template>-->
                    <!--                    </Column>-->

                    <Column
                      header="Current RE"
                      field="newAmount"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.newAmount) }}
                      </template>
                    </Column>
                    <Column
                      header="Prior RE"
                      field="oldAmount"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.oldAmount) }}
                      </template>
                    </Column>
                    <Column
                      header="Variance"
                      field="differenceAmount"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        <div>
                          <dme-arrow
                            :diff="props.data.differenceAmount"
                          ></dme-arrow>
                          {{ formatAmount(props.data.differenceAmount) }}
                          <div class="variance-percent">
                            {{
                              variancePercent(
                                props.data.newAmount,
                                props.data.oldAmount
                              )
                            }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column
                      header="Action"
                      headerStyle="width: 12rem;"
                      bodyStyle="width: 12rem;"
                    >
                      <template #body="props">
                        <div class="p-buttons" v-if="props.data.approveNeed">
                          <Button
                            class="p-button-sm p-button-success"
                            :class="{ 'p-button-text': !props.data.approveYes }"
                            @click="onApproveLv2(props.data)"
                            :label="
                              props.data.approveNeed === 'A'
                                ? 'Acknowlege'
                                : 'Approve'
                            "
                          ></Button>
                          <Button
                            v-if="props.data.approveNeed !== 'A'"
                            class="p-button-sm p-button-danger p-ml-2"
                            :class="{ 'p-button-text': !props.data.approveNo }"
                            @click="onRejectLv2(props.data)"
                            label="Reject"
                          ></Button>
                        </div>
                      </template>
                    </Column>
                    <Column header="Comment">
                      <template #body="props">
                        <Textarea
                          v-model="props.data.comment"
                          v-if="props.data.approveNeed"
                          :rows="1"
                          :disabled="props.data.approveNo !== 'X'"
                          style="width: 100%"
                        ></Textarea>
                      </template>
                    </Column>
                    <template #empty="">ไม่พบข้อมูล</template>
                  </DataTable>
                </div>
              </div>
            </TabPanel>
            <TabPanel v-if="approveLv2Summary.length > 0">
              <template #header="">
                <i class="pi pi-star p-mr-2"></i>
                <span
                  :class="
                    isLevel2SummaryCompleted ? 'tab-success' : 'tab-danger'
                  "
                >
                  {{ level2SummaryTabName }}
                </span>
              </template>
              <div class="p-grid">
                <div class="p-col-12" v-if="showAcceptLevel2Summary">
                  <span class="p-d-flex p-justify-end">
                    <Button
                      label="Approve All"
                      class="p-button-success"
                      @click="onAcceptAllLevel2Summary"
                    ></Button>
                  </span>
                </div>
                <div class="p-col-12">
                  <DataTable
                    :value="approveLv2Summary"
                    class="p-datatable-sm"
                    showGridlines
                    :rowClass="rowClassLevel2SummaryCurrent"
                  >
                    <template #header=""
                      ><span class="table-header">Current Quarter</span>
                    </template>
                    <template #empty="">ไม่พบข้อมูล</template>
                    <Column header="Cost Center Level 1">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel1"
                          v-tooltip="props.data.wbsLevel1"
                        >
                          <!--                          {{ props.data.wbsLevel1 }} :-->
                          {{ props.data.wbsLevelDescription1 }}
                        </span>
                      </template>
                    </Column>
                    <Column header="Cost Center Level 2">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel2"
                          v-tooltip="props.data.wbsLevel2"
                        >
                          <!--                          {{ props.data.wbsLevel2 }} :-->
                          {{ props.data.wbsLevelDescription2 }}
                        </span>
                      </template>
                    </Column>
                    <Column
                      header="Current RE"
                      field="currentQuarterNew"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.currentQuarterNew) }}
                      </template>
                    </Column>
                    <Column
                      header="Prior RE"
                      field="currentQuarterOld"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.currentQuarterOld) }}
                      </template>
                    </Column>
                    <Column
                      header="Variance"
                      field="currentQuarterDifference"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        <div>
                          <dme-arrow
                            :diff="props.data.currentQuarterDifference"
                          ></dme-arrow>
                          {{
                            formatAmount(props.data.currentQuarterDifference)
                          }}
                          <div class="variance-percent">
                            {{
                              variancePercent(
                                props.data.currentQuarterNew,
                                props.data.currentQuarterOld
                              )
                            }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column
                      header="Action"
                      headerStyle="width: 12rem;"
                      bodyStyle="width: 12rem;"
                    >
                      <template #body="props">
                        <div
                          class="p-buttons"
                          v-if="props.data.currentQuarterApproveNeed"
                        >
                          <Button
                            class="p-button-sm p-button-success"
                            :class="{
                              'p-button-text': !props.data
                                .currentQuarterApproveYes,
                            }"
                            @click="onApproveLv2(props.data, 'current')"
                            :label="
                              props.data.approveNeed === 'A'
                                ? 'Acknowlege'
                                : 'Approve'
                            "
                          ></Button>
                          <Button
                            v-if="props.data.approveNeed !== 'A'"
                            class="p-button-sm p-button-danger p-ml-2"
                            :class="{
                              'p-button-text': !props.data
                                .currentQuarterApproveNo,
                            }"
                            @click="onRejectLv2(props.data, 'current')"
                            label="Reject"
                          ></Button>
                        </div>
                      </template>
                    </Column>
                    <Column header="Comment">
                      <template #body="props">
                        <Textarea
                          v-model="props.data.currentQuarterComment"
                          v-if="props.data.currentQuarterApproveNeed"
                          :rows="1"
                          :disabled="
                            props.data.currentQuarterApproveNo !== 'X' &&
                              !isVpPosition
                          "
                          style="width: 100%"
                        ></Textarea>
                      </template>
                    </Column>
                  </DataTable>
                </div>
                <div class="p-col-12">
                  <DataTable
                    :value="approveLv2Summary"
                    class="p-datatable-sm"
                    showGridlines
                    :rowClass="rowClassLevel2SummaryNext"
                  >
                    <template #header="">
                      <span class="table-header">Next Quarter</span>
                    </template>
                    <template #empty="">ไม่พบข้อมูล</template>
                    <Column header="Cost Center Level 1">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel1"
                          v-tooltip="props.data.wbsLevel1"
                        >
                          <!--                          {{ props.data.wbsLevel1 }} :-->
                          {{ props.data.wbsLevelDescription1 }}
                        </span>
                      </template>
                    </Column>
                    <Column header="Cost Center Level 2">
                      <template #body="props">
                        <span
                          v-if="props.data.wbsLevel2"
                          v-tooltip="props.data.wbsLevel2"
                        >
                          <!--                          {{ props.data.wbsLevel2 }} :-->
                          {{ props.data.wbsLevelDescription2 }}
                        </span>
                      </template>
                    </Column>
                    <Column
                      header="Current RE"
                      field="nextQuarterNew"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.nextQuarterNew) }}
                      </template>
                    </Column>
                    <Column
                      header="Prior RE"
                      field="nextQuarterOld"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        {{ formatAmount(props.data.nextQuarterOld) }}
                      </template>
                    </Column>
                    <Column
                      header="Variance"
                      field="nextQuarterDifference"
                      headerClass="numeral-column"
                      bodyStyle="text-align: right"
                    >
                      <template #body="props">
                        <div>
                          <dme-arrow
                            :diff="props.data.nextQuarterDifference"
                          ></dme-arrow>
                          {{ formatAmount(props.data.nextQuarterDifference) }}
                          <div class="variance-percent">
                            {{
                              variancePercent(
                                props.data.nextQuarterNew,
                                props.data.nextQuarterOld
                              )
                            }}
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column
                      header="Action"
                      headerStyle="width: 12rem;"
                      bodyStyle="width: 12rem;"
                    >
                      <template #body="props">
                        <div
                          class="p-buttons"
                          v-if="props.data.nextQuarterApproveNeed"
                        >
                          <Button
                            class="p-button-sm p-button-success"
                            :class="{
                              'p-button-text': !props.data
                                .nextQuarterApproveYes,
                            }"
                            @click="onApproveLv2(props.data, 'next')"
                            :label="
                              props.data.approveNeed === 'A'
                                ? 'Acknowlege'
                                : 'Approve'
                            "
                          ></Button>
                          <Button
                            v-if="props.data.approveNeed !== 'A'"
                            class="p-button-sm p-button-danger p-ml-2"
                            :class="{
                              'p-button-text': !props.data.nextQuarterApproveNo,
                            }"
                            @click="onRejectLv2(props.data, 'next')"
                            label="Reject"
                          ></Button>
                        </div>
                      </template>
                    </Column>
                    <Column header="Comment">
                      <template #body="props">
                        <Textarea
                          v-model="props.data.nextQuarterComment"
                          v-if="props.data.nextQuarterApproveNeed"
                          :rows="1"
                          :disabled="
                            props.data.nextQuarterApproveNo !== 'X' &&
                              !isVpPosition
                          "
                          style="width: 100%"
                        ></Textarea>
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </template>
  </Card>
  
</template>

<script lang="ts">
import usePlugin from "@/plugins";
import { useTitle } from "@vueuse/core";
import {
  ApproveGetRequest,
  ApproveGetResponse,
  ApproveLv1,
  ApproveLv2,
  ApproveLv2Summary,
  ApproveSetRequest,
  ApproveSetResponse,
} from "@/types";
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import ProgressSpinner from "primevue/progressspinner";
import numeral from "numeral";
import DmeArrow from "@/components/dme/DmeArrow.vue";
import App from "@/App.vue";
import { clone } from "ramda";

const initRequest = {
  approverId: "VP1",
  approverYear: 2022,
  guId: "",
  currentQuarterOverallComment: "",
  nextQuarterOverallComment: "",
  yearOverallComment: "",
  currentQuarterOverallComment1: "",
  nextQuarterOverallComment1: "",
  yearOverallComment1: "",
  currentQuarterOverallComment2: "",
  nextQuarterOverallComment2: "",
  currentQuarterOverallComment3: "",
  nextQuarterOverallComment3: "",
  currentQuarterOverallComment4: "",
  nextQuarterOverallComment4: "",
  yearOverallComment2: "",
  yearOverallComment3: "",
  yearOverallComment4: "",
  isLoading: false,
  allComment: "",
  tabIndex: 0,
  commentToNextApprover: "",
};

export default defineComponent({
  name: "DmeApproveScreen",
  components: { ProgressSpinner, DmeArrow },
  setup() {
    const { axios, error, success, router, warning } = usePlugin();
    const request = reactive(clone(initRequest));
    const approveLv1s = ref<ApproveLv1[]>([]);
    const approveLv2s = ref<ApproveLv2[]>([]);
    const approveLv2Summary = ref<ApproveLv2Summary[]>([]);
    // const approveLv1s = useLocalStorage<ApproveLv1[]>("approveLv1s", []);
    // const approveLv2s = useLocalStorage<ApproveLv2[]>("approveLv2s", []);
    // const approveLv2Summary = useLocalStorage<ApproveLv2Summary[]>(
    //   "approveLv2Summary",
    //   []
    // );
    const hasDisplay1 = computed(
      () =>
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex((x) => x.previousCommentName1) >= 0
    );
    const hasDisplay2 = computed(
      () =>
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex((x) => x.previousCommentName2) >= 0
    );
    const hasDisplay3 = computed(
      () =>
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex((x) => x.previousCommentName3) >= 0
    );
    const hasDisplay4 = computed(
      () =>
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex((x) => x.previousCommentName4) >= 0
    );
    const hasDisplay = computed(() => hasDisplay1.value || hasDisplay2.value || hasDisplay3.value || hasDisplay4.value);

    const isVpPosition = computed(() => position.value === "VP");
    const isCeoPosition = computed(() => position.value === "CEO");

    const position = computed(() => {
      if (approveLv1s.value.length > 0) {
        return approveLv1s.value[0].approverId.replace(/[0-9]/g, "");
      }
      if (approveLv2s.value.length > 0) {
        return approveLv2s.value[0].approverId.replace(/[0-9]/g, "");
      }
      return "N/A";
    });

    const showCommentToNextApprover = computed(() => {
      return (
        approveLv2s.value.length > 0 &&
        approveLv2s.value.filter((x) => x.approveNeed).length ===
          approveLv2s.value.filter((x) => x.approveNeed && x.approveYes).length
      );
    });

    const onLoad = async (fromSave = false) => {
      try {
        request.isLoading = true;
        const result = await axios.post<ApproveGetResponse>(
          "api/v1/dme/approve/get",
          {
            approverId: request.approverId,
            approverYear: request.approverYear,
            guId: request.guId,
          } as ApproveGetRequest
        );

        //clear reactive request
        request.commentToNextApprover = "";
        request.tabIndex = 0;
        request.allComment = "";
        request.currentQuarterOverallComment = "";
        request.nextQuarterOverallComment = "";
        request.yearOverallComment = "";
        request.currentQuarterOverallComment1 = "";
        request.nextQuarterOverallComment1 = "";
        request.yearOverallComment1 = "";
        request.currentQuarterOverallComment2 = "";
        request.nextQuarterOverallComment2 = "";
        request.yearOverallComment2 = "";

        approveLv1s.value = result.data.approverOutput.approveLv1s ?? [];
        approveLv2s.value = result.data.approverOutput.approveLv2s ?? [];
        approveLv2Summary.value =
          result.data.approverOutput.approveLv2Sums ?? [];

        if (hasDisplay1.value) {
          request.currentQuarterOverallComment1 = `Overall ${
            approveLv1s.value[0].previousCommentName1
          } : ${approveLv1s.value[0].currentQuarterPreviousComment1Overall ||
            "N/A"}`;
          request.nextQuarterOverallComment1 = `Overall ${
            approveLv1s.value[0].previousCommentName1
          } : ${approveLv1s.value[0].nextQuarterPreviousComment1Overall ||
            "N/A"}`;
          request.yearOverallComment1 = `Overall ${
            approveLv1s.value[0].previousCommentName1
          } : ${approveLv1s.value[0].yearPreviousComment1Overall || "N/A"}`;
        }
        if (hasDisplay2.value) {
          request.currentQuarterOverallComment2 = `Overall ${
            approveLv1s.value[0].previousCommentName2
          } : ${approveLv1s.value[0].currentQuarterPreviousComment2Overall ||
            "N/A"}`;
          request.nextQuarterOverallComment2 = `Overall ${
            approveLv1s.value[0].previousCommentName2
          } : ${approveLv1s.value[0].nextQuarterPreviousComment2Overall ||
            "N/A"}`;
          request.yearOverallComment2 = `Overall ${
            approveLv1s.value[0].previousCommentName2
          } : ${approveLv1s.value[0].yearPreviousComment2Overall || "N/A"}`;
        }
        if (hasDisplay3.value) {
          request.currentQuarterOverallComment3 = `Overall ${
            approveLv1s.value[0].previousCommentName3
          } : ${approveLv1s.value[0].currentQuarterPreviousComment3Overall ||
            "N/A"}`;
          request.nextQuarterOverallComment3 = `Overall ${
            approveLv1s.value[0].previousCommentName3
          } : ${approveLv1s.value[0].nextQuarterPreviousComment3Overall ||
            "N/A"}`;
          request.yearOverallComment3 = `Overall ${
            approveLv1s.value[0].previousCommentName3
          } : ${approveLv1s.value[0].yearPreviousComment3Overall || "N/A"}`;
        }
        if (hasDisplay4.value) {
          request.currentQuarterOverallComment4 = `Overall ${
            approveLv1s.value[0].previousCommentName4
          } : ${approveLv1s.value[0].currentQuarterPreviousComment4Overall ||
            "N/A"}`;
          request.nextQuarterOverallComment4 = `Overall ${
            approveLv1s.value[0].previousCommentName4
          } : ${approveLv1s.value[0].nextQuarterPreviousComment4Overall ||
            "N/A"}`;
          request.yearOverallComment4 = `Overall ${
            approveLv1s.value[0].previousCommentName4
          } : ${approveLv1s.value[0].yearPreviousComment4Overall || "N/A"}`;
        }

        if (result.data.approverOutput.returns.length === 0) {
          success("Data has been loaded successfully.");
          
          if(!fromSave && !showAcceptLevel1.value && !showAcceptLevel2.value && !showAcceptLevel2Summary.value){
            warning('Sorry, you have already completed this transaction.', true)
          }
        } else {
          error(JSON.stringify(result.data.approverOutput.returns, null, 2));
        }
      } catch (e) {
        error(e);
      } finally {
        request.isLoading = false;
      }

      // approveLv1s.value.forEach((x) => {
      //   x.currentQuarter = "D";
      //   x.nextQuarter = "D";
      // });
      // approveLv2s.value.forEach((x, i) => {
      //   if (i % 2 === 0) x.approveNeed = "X";
      // });
      // approveLv2Summary.value.forEach((x) => {
      //   x.nextQuarterApproveNeed = "X";
      //   x.currentQuarterApproveNeed = "X";
      //   x.yearApproveNeed = "X";
      // });

      // fakeApprove()
    };
    const onApproveLv1 = (input: ApproveLv1, inputCase: string) => {
      if (inputCase === "current") {
        input.currentQuarterApproveYes = "X";
        input.currentQuarterApproveNo = "";
      } else if (inputCase === "next") {
        input.nextQuarterApproveYes = "X";
        input.nextQuarterApproveNo = "";
      } else if (inputCase === "year") {
        input.yearApproveYes = "X";
        input.yearApproveNo = "";
      }
    };
    const onRejectLv1 = (input: ApproveLv1, inputCase: string) => {
      if (inputCase === "current") {
        input.currentQuarterApproveYes = "";
        input.currentQuarterApproveNo = "X";
      } else if (inputCase === "next") {
        input.nextQuarterApproveYes = "";
        input.nextQuarterApproveNo = "X";
      } else if (inputCase === "year") {
        input.yearApproveYes = "";
        input.yearApproveNo = "X";
      }
    };

    const onApproveLv2 = (input: any, inputCase?: string) => {
      if (inputCase === undefined) {
        input.approveYes = "X";
        input.approveNo = "";
      } else if (inputCase === "current") {
        input.currentQuarterApproveYes = "X";
        input.currentQuarterApproveNo = "";
      } else if (inputCase === "next") {
        input.nextQuarterApproveYes = "X";
        input.nextQuarterApproveNo = "";
      }
    };
    const onRejectLv2 = (input: any, inputCase?: string) => {
      if (inputCase === undefined) {
        input.approveYes = "";
        input.approveNo = "X";
      } else if (inputCase === "current") {
        input.currentQuarterApproveYes = "";
        input.currentQuarterApproveNo = "X";
      } else if (inputCase === "next") {
        input.nextQuarterApproveYes = "";
        input.nextQuarterApproveNo = "X";
      }
    };
    const copyOverallComment = () => {
      approveLv1s.value.forEach((x) => {
        x.currentQuarterCommentOverall =
          request.currentQuarterOverallComment && x.approveNeed
            ? request.currentQuarterOverallComment
            : x.currentQuarterCommentOverall;
        x.nextQuarterCommentOverall =
          request.nextQuarterOverallComment && x.approveNeed
            ? request.nextQuarterOverallComment
            : x.nextQuarterCommentOverall;
        x.yearCommentOverall =
          request.yearOverallComment && x.approveNeed
            ? request.yearOverallComment
            : x.yearCommentOverall;
      });
    };

    const copyCommentToNextApprover = () => {
      if (
        isVpPosition.value &&
        showCommentToNextApprover.value &&
        request.commentToNextApprover
      ) {
        approveLv2s.value.forEach((x) => {
          x.comment = request.commentToNextApprover;
        });
      }
    };
    const onSubmit = async () => {
      if (
        !isLevel1Completed.value ||
        !isLevel2Completed.value ||
        !isLevel2SummaryCompleted.value
      ) {
        error("error : please complete action all tab");
        return;
      }
      copyOverallComment();
      copyCommentToNextApprover();

      try {
        request.isLoading = true;
        const result = await axios.post<ApproveSetResponse>(
          "api/v1/dme/approve/set",
          {
            approveLv1s: approveLv1s.value ?? [],
            approveLv2s: approveLv2s.value ?? [],
            approveLv2Summary: approveLv2Summary.value ?? [],
          } as ApproveSetRequest
        );
        if (result.data.bapiRet2s.length === 0) {
          success("ทำรายการสำเร็จ / transaction successful", true);
        } else {
          error(JSON.stringify(result.data.bapiRet2s, null, 2), null, true);
        }
        await onLoad(true);
      } catch (e) {
        error(e);
      } finally {
        request.isLoading = false;
      }
    };

    // const onAcceptAll = () => {
    //   request.tabIndex = 0;
    //   approveLv2s.value
    //     .filter((x) => x.approveNeed)
    //     .forEach((x) => (x.approveYes = "X"));
    //   approveLv2s.value
    //     .filter((x) => x.approveNeed)
    //     .forEach((x) => (x.approveNo = ""));
    //   approveLv2s.value
    //     .filter((x) => x.approveNeed)
    //     .forEach((x) => (x.comment = request.allComment));
    //   success("ทำการ Mark Approve ทั้งหมดแล้ว กรุณาตรวจสอบและบันทึกรายการ");
    // };

    // const onRejectAll = () => {
    //   request.tabIndex = 0;
    //   approveLv2s.value
    //     .filter((x) => x.approveNeed)
    //     .forEach((x) => (x.approveYes = ""));
    //   approveLv2s.value
    //     .filter((x) => x.approveNeed)
    //     .forEach((x) => (x.approveNo = "X"));
    //   approveLv2s.value
    //     .filter((x) => x.approveNeed)
    //     .forEach((x) => (x.comment = request.allComment));
    //   success("ทำการ Mark Reject ทั้งหมดแล้ว กรุณาตรวจสอบและบันทึกรายการ");
    // };

    const hasLevel2Approve = computed(
      () => approveLv2s.value.findIndex((x) => x.approveNeed) >= 0
    );
    const hasNormalApprove = computed(
      () => approveLv2s.value.findIndex((x) => x.approveNeed === "X") >= 0
    );

    const formatAmount = (input: number) => {
      return numeral(input).format("#,###,###.00");
    };

    const onAcceptAllLevel1 = () => {
      approveLv1s.value.forEach((x) => {
        if (x.approveNeed && x.nextQuarterApproveNeed) {
          x.nextQuarterApproveYes = "X";
          x.nextQuarterApproveNo = "";
        }
        if (x.approveNeed && x.currentQuarterApproveNeed) {
          x.currentQuarterApproveYes = "X";
          x.currentQuarterApproveNo = "";
        }
        if (x.approveNeed && x.yearApproveNeed) {
          x.yearApproveYes = "X";
          x.yearApproveNo = "";
        }
      });
    };
    const onAcceptAllLevel2 = () => {
      approveLv2s.value.forEach((x) => {
        if (x.approveNeed) {
          x.approveYes = "X";
          x.approveNo = "";
        }
      });
    };
    const onAcceptAllLevel2Summary = () => {
      approveLv2Summary.value.forEach((x) => {
        if (x.nextQuarterApproveNeed) {
          x.nextQuarterApproveYes = "X";
          x.nextQuarterApproveNo = "";
        }
        if (x.currentQuarterApproveNeed) {
          x.currentQuarterApproveYes = "X";
          x.currentQuarterApproveNo = "";
        }
      });
    };

    const showAcceptLevel1 = computed(() => {
      return approveLv1s.value.findIndex((x) => x.approveNeed) >= 0;
    });
    const showAcceptLevel2 = computed(() => {
      return approveLv2s.value.findIndex((x) => x.approveNeed) >= 0;
    });
    const showAcceptLevel2Summary = computed(() => {
      return (
        approveLv2Summary.value.findIndex(
          (x) => x.nextQuarterApproveNeed || x.currentQuarterApproveNeed
        ) >= 0
      );
    });

    const isLevel1CurrentAllAccept = computed(() => {
      return (
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex(
          (x) => x.approveNeed && x.currentQuarterApproveNeed
        ) >= 0 &&
        approveLv1s.value.filter(
          (x) => x.approveNeed && x.currentQuarterApproveNeed
        ).length ===
          approveLv1s.value.filter(
            (x) =>
              x.approveNeed &&
              x.currentQuarterApproveNeed &&
              x.currentQuarterApproveYes
          ).length
      );
    });
    const isLevel1NextAllAccept = computed(() => {
      return (
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex(
          (x) => x.approveNeed && x.nextQuarterApproveNeed
        ) >= 0 &&
        approveLv1s.value.filter(
          (x) => x.approveNeed && x.nextQuarterApproveNeed
        ).length ===
          approveLv1s.value.filter(
            (x) =>
              x.approveNeed &&
              x.nextQuarterApproveNeed &&
              x.nextQuarterApproveYes
          ).length
      );
    });
    const isLevel1YearAllAccept = computed(() => {
      return (
        approveLv1s.value.length > 0 &&
        approveLv1s.value.findIndex(
          (x) => x.approveNeed && x.yearApproveNeed
        ) >= 0 &&
        approveLv1s.value.filter((x) => x.approveNeed && x.yearApproveNeed)
          .length ===
          approveLv1s.value.filter(
            (x) => x.approveNeed && x.yearApproveNeed && x.yearApproveYes
          ).length
      );
    });

    useTitle("DME Approve");

    const isLevel1Completed = computed(() => {
      if (approveLv1s.value.length === 0) return true;
      return (
        approveLv1s.value.filter((x) => x.approveNeed && x.yearApproveNeed)
          .length ===
          approveLv1s.value.filter(
            (x) =>
              x.approveNeed &&
              x.yearApproveNeed &&
              (x.yearApproveYes || x.yearApproveNo)
          ).length &&
        approveLv1s.value.filter(
          (x) => x.approveNeed && x.currentQuarterApproveNeed
        ).length ===
          approveLv1s.value.filter(
            (x) =>
              x.approveNeed &&
              x.currentQuarterApproveNeed &&
              (x.currentQuarterApproveYes || x.currentQuarterApproveNo)
          ).length &&
        approveLv1s.value.filter(
          (x) => x.approveNeed && x.nextQuarterApproveNeed
        ).length ===
          approveLv1s.value.filter(
            (x) =>
              x.approveNeed &&
              x.nextQuarterApproveNeed &&
              (x.nextQuarterApproveYes || x.nextQuarterApproveNo)
          ).length
      );
    });
    const isLevel2Completed = computed(() => {
      if (approveLv2s.value.length === 0) return true;
      return (
        approveLv2s.value.filter((x) => x.approveNeed).length ===
        approveLv2s.value.filter(
          (x) => x.approveNeed && (x.approveYes || x.approveNo)
        ).length
      );
    });
    const isLevel2SummaryCompleted = computed(() => {
      if (approveLv2Summary.value.length === 0) return true;
      return (
        approveLv2Summary.value.filter((x) => x.nextQuarterApproveNeed)
          .length ===
          approveLv2Summary.value.filter(
            (x) =>
              x.nextQuarterApproveNeed &&
              (x.nextQuarterApproveYes || x.nextQuarterApproveNo)
          ).length &&
        approveLv2Summary.value.filter((x) => x.currentQuarterApproveNeed)
          .length ===
          approveLv2Summary.value.filter(
            (x) =>
              x.currentQuarterApproveNeed &&
              (x.currentQuarterApproveYes || x.currentQuarterApproveNo)
          ).length
      );
    });

    const queryGuId = computed(
      () => (router.currentRoute.value.query["guid"] as string) ?? ""
    );

    const rowClassLevel1Current = (row: ApproveLv1) =>
      row.approveNeed && row.currentQuarterApproveNeed
        ? "attention-require"
        : "";
    const rowClassLevel1Year = (row: ApproveLv1) =>
      row.approveNeed && row.yearApproveNeed ? "attention-require" : "";
    const rowClassLevel1Next = (row: ApproveLv1) =>
      row.approveNeed && row.nextQuarterApproveNeed ? "attention-require" : "";
    const rowClassLevel2 = (row: ApproveLv2) => {
      return {
        level1: row.wbsLevel1 && !row.wbsLevel2 && !row.wbsLevel4,
        level2: row.wbsLevel1 && row.wbsLevel2 && !row.wbsLevel4,
        level3: row.wbsLevel1 && row.wbsLevel2 && row.wbsLevel4,
        "attention-require": row.approveNeed,
      };
    };

    const rowClassLevel2SummaryCurrent = (row: ApproveLv2Summary) => {
      return {
        level1: row.wbsLevel1 && !row.wbsLevel2,
        level3: row.wbsLevel1 && row.wbsLevel2,
        "attention-require": row.currentQuarterApproveNeed,
      };
    };
    const rowClassLevel2SummaryNext = (row: ApproveLv2Summary) => {
      return {
        level1: row.wbsLevel1 && !row.wbsLevel2,
        level3: row.wbsLevel1 && row.wbsLevel2,
        "attention-require": row.nextQuarterApproveNeed,
      };
    };

    const showSelectionSection = computed(() => {
      return (
        window.origin.indexOf("api.haadthip.com") < 0 &&
        window.origin.indexOf("apiqas.haadthip.com") < 0
      );
    });

    const variancePercent = (newVal: number, oldVal: number): string => {
      const result =
        oldVal === 0 && newVal !== 0 ? 1 : (newVal - oldVal) / oldVal;
      return numeral(result).format("0,0.00%");
    };

    const level1TabName = computed(() => {
      return position.value === "COO" ||
        position.value === "CFO" ||
        position.value === "CEO"
        ? "Approval"
        : position.value === "FP" || position.value?.startsWith("COM")
        ? "Acknowledgement"
        : "รายละเอียด Lv1";
    });

    const level2TabName = computed(() => {
      return position.value === "COO" ||
        position.value === "CFO" ||
        position.value === "CEO" ||
        position.value === "FP" ||
        position.value?.startsWith("COM")
        ? "Full year details"
        : position.value === "VP"
        ? "FULL YEAR Budget"
        : "รายละเอียด Lv2";
    });

    const level2SummaryTabName = computed(() => {
      return position.value === "COO" ||
        position.value === "CFO" ||
        position.value === "CEO" ||
        position.value === "FP" ||
        position.value?.startsWith("COM")
        ? "Quarter details"
        : position.value === "VP"
        ? "Quarter budget"
        : "ภาพรวม";
    });

    const totalCurrentQuarterNew = computed(() =>
      approveLv1s.value.map((x) => x.currentQuarterNew).reduce((x, y) => x + y)
    );
    const totalCurrentQuarterOld = computed(() =>
      approveLv1s.value.map((x) => x.currentQuarterOld).reduce((x, y) => x + y)
    );
    const totalCurrentQuarterDiff = computed(
      () => totalCurrentQuarterNew.value - totalCurrentQuarterOld.value
    );

    const totalNextQuarterNew = computed(() =>
      approveLv1s.value.map((x) => x.nextQuarterNew).reduce((x, y) => x + y)
    );
    const totalNextQuarterOld = computed(() =>
      approveLv1s.value.map((x) => x.nextQuarterOld).reduce((x, y) => x + y)
    );
    const totalNextQuarterDiff = computed(
      () => totalNextQuarterNew.value - totalNextQuarterOld.value
    );

    const totalYearNew = computed(() =>
      approveLv1s.value.map((x) => x.yearNew).reduce((x, y) => x + y)
    );
    const totalYearOld = computed(() =>
      approveLv1s.value.map((x) => x.yearOld).reduce((x, y) => x + y)
    );
    const totalYearDiff = computed(
      () => totalYearNew.value - totalYearOld.value
    );

    const commentVpHeader = computed(() =>
      approveLv1s.value.length > 0 &&
      approveLv1s.value[0].previousCommentNameVp &&
      approveLv1s.value[0].previousCommentNameVp !== "N"
        ? approveLv1s.value[0].previousCommentNameVp
        : null
    );
    const comment1Header = computed(() =>
      approveLv1s.value.length > 0 &&
      approveLv1s.value[0].previousCommentName1 &&
      approveLv1s.value[0].previousCommentName1 !== "N"
        ? approveLv1s.value[0].previousCommentName1
        : null
    );
    const comment2Header = computed(() =>
      approveLv1s.value.length > 0 &&
      approveLv1s.value[0].previousCommentName2 &&
      approveLv1s.value[0].previousCommentName2 !== "N"
        ? approveLv1s.value[0].previousCommentName2
        : null
    );
    const comment3Header = computed(() =>
      approveLv1s.value.length > 0 &&
      approveLv1s.value[0].previousCommentName3 &&
      approveLv1s.value[0].previousCommentName3 !== "N"
        ? approveLv1s.value[0].previousCommentName3
        : null
    );
    const comment4Header = computed(() =>
      approveLv1s.value.length > 0 &&
      approveLv1s.value[0].previousCommentName4 &&
      approveLv1s.value[0].previousCommentName4 !== "N"
        ? approveLv1s.value[0].previousCommentName4
        : null
    );

    onMounted(async () => {
      request.guId = queryGuId.value;
      if (request.guId) {
        await onLoad();
      }
    });

    const fakeApprove = () => {
      console.log("FAKE APPROVE");
      approveLv1s.value.forEach((x) => {
        x.approveNeed = "A";
        x.yearApproveNeed = "X";
        x.currentQuarterApproveNeed = "X";
        x.nextQuarterApproveNeed = "X";
      });
      approveLv2s.value.forEach((x) => {
        if (x.wbsLevel4) {
          x.approveNeed = "X";
        }
      });
    };

    return {
      request,
      onLoad,
      approveLv1s,
      approveLv2s,
      approveLv2Summary,
      onApproveLv1,
      onRejectLv1,
      onApproveLv2,
      onRejectLv2,
      onSubmit,

      isVpPosition,
      isCeoPosition,
      showCommentToNextApprover,
      showSelectionSection,

      // onAcceptAll,
      // onRejectAll,
      onAcceptAllLevel1,
      onAcceptAllLevel2,
      onAcceptAllLevel2Summary,

      showAcceptLevel1,
      showAcceptLevel2,
      showAcceptLevel2Summary,

      isLevel1YearAllAccept,
      isLevel1CurrentAllAccept,
      isLevel1NextAllAccept,

      isLevel1Completed,
      isLevel2Completed,
      isLevel2SummaryCompleted,

      hasDisplay,
      hasDisplay1,
      hasDisplay2,
      hasDisplay3,
      hasDisplay4,
      hasLevel2Approve,
      hasNormalApprove,
      formatAmount,

      queryGuId,

      rowClassLevel1Next,
      rowClassLevel1Year,
      rowClassLevel1Current,
      rowClassLevel2SummaryNext,
      rowClassLevel2SummaryCurrent,
      rowClassLevel2,

      variancePercent,

      level1TabName,
      level2TabName,
      level2SummaryTabName,

      totalCurrentQuarterNew,
      totalCurrentQuarterOld,
      totalCurrentQuarterDiff,
      totalNextQuarterNew,
      totalNextQuarterOld,
      totalNextQuarterDiff,
      totalYearNew,
      totalYearOld,
      totalYearDiff,

      commentVpHeader,
      comment1Header,
      comment2Header,
      comment3Header,
      comment4Header,
    };
  },
});
</script>

<style scoped>
/* sarabun-regular - thai_latin */
@font-face {
  font-family: "Sarabun";
  font-style: normal;
  font-weight: 400;
  src: url("../../../public/fonts/sarabun-v8-thai_latin-regular.eot"); /* IE9 Compat Modes */
  src: local(""),
    url("../../../public/fonts/sarabun-v8-thai_latin-regular.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */
      url("../../../public/fonts/sarabun-v8-thai_latin-regular.woff2")
      format("woff2"),
    /* Super Modern Browsers */
      url("../../../public/fonts/sarabun-v8-thai_latin-regular.woff")
      format("woff"),
    /* Modern Browsers */
      url("../../../public/fonts/sarabun-v8-thai_latin-regular.ttf")
      format("truetype"),
    /* Safari, Android, iOS */
      url("../../../public/fonts/sarabun-v8-thai_latin-regular.svg#Sarabun")
      format("svg"); /* Legacy iOS */
}

.table-header {
  font-size: 1.1rem;
  font-weight: bold;
}

.p-card {
  border: 1px black solid;
  font-family: "Sarabun", "Franklin Gothic Medium", "Arial Narrow", Arial,
    sans-serif;
}

.p-card,
.p-button,
.p-datatable,
.p-inputtext,
.p-tabview {
  font-family: "Sarabun", "Franklin Gothic Medium", "Arial Narrow", Arial,
    sans-serif;
}

.p-tabview-nav-link {
  padding: 0.8rem;
}
</style>
<style>
.numeral-column > div > span {
  width: 100%;
  text-align: right;
}

.tab-success {
  color: green;
}

.tab-danger {
  color: red;
  text-decoration: underline;
}

.p-datatable .p-datatable-thead > tr > th {
  background: #0078d4 !important;
  color: white !important;
  font-weight: normal !important;
}

.attention-require {
  /*background: #eaecff !important;*/
  border: 2px #fa8a8a dotted !important;
}

.level1 {
  background: #96d5a3 !important;
}

.level2 {
  background: #c2e3c7 !important;
}

.level3 {
  background: #f3fff6 !important;
}

.variance-percent {
  font-size: 0.7rem;
}

.overallCommentLabel {
  font-weight: bold;
}

.table-header {
  text-transform: uppercase;
  font-size: 1.5rem !important;
}
</style>
